export const environment = {
  production: false,
  //   apiUrl: 'http://localhost:3006'
  apiUrl: 'https://intel-api.nabt.app',
};
